import React from 'react';
import { MetaPixel } from './components/MetaPixel';
import { StickyUrgencyBar } from './components/StickyUrgencyBar';
import { ProgressBar } from './components/ProgressBar';
import { StickyCTABar } from './components/StickyCTABar';
import { ExitIntentPopup } from './components/ExitIntentPopup';
import { SocialProofToast } from './components/SocialProofToast';
import { HeroSection } from './components/HeroSection';
import { IdentificationSection } from './components/IdentificationSection';
import { CostOfWaitingSection } from './components/CostOfWaitingSection';
import { WhyItFailedSection } from './components/WhyItFailedSection';
import { CierreMethodSection } from './components/CierreMethodSection';
import { ValidationSection } from './components/ValidationSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { BenefitsGrid } from './components/BenefitsGrid';
import { WhatYouGetSection } from './components/WhatYouGetSection';
import { BonusesSection } from './components/BonusesSection';
import { OfferSummarySection } from './components/OfferSummarySection';
import { CheckoutSection } from './components/CheckoutSection';
import { TrustMicrosection } from './components/TrustMicrosection';
import { FAQSection } from './components/FAQSection';
import { EmotionalClosingSection } from './components/EmotionalClosingSection';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-cream font-sans text-ink selection:bg-soft/50 selection:text-primary" data-id="element-0">
      <MetaPixel data-id="element-1" />
      <ProgressBar data-id="element-2" />
      <StickyUrgencyBar data-id="element-3" />
      <StickyCTABar data-id="element-4" />
      <ExitIntentPopup data-id="element-5" />
      <SocialProofToast data-id="element-6" />

      <main data-id="element-7">
        <HeroSection data-id="element-8" />
        <IdentificationSection data-id="element-9" />
        <CostOfWaitingSection data-id="element-10" />
        <WhyItFailedSection data-id="element-11" />
        <CierreMethodSection data-id="element-12" />
        <ValidationSection data-id="element-13" />
        <BenefitsGrid data-id="element-14" />
        <WhatYouGetSection data-id="element-15" />
        <BonusesSection data-id="element-16" />
        <OfferSummarySection data-id="element-17" />
        <TestimonialsSection data-id="element-18" />
        <FAQSection data-id="element-19" />
        <CheckoutSection data-id="element-20" />
        <TrustMicrosection data-id="element-21" />
        <EmotionalClosingSection data-id="element-22" />
      </main>

      <Footer data-id="element-23" />
    </div>;
}